// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c060e10b","239":"0cc362c0","453":"df05f35a","455":"89fea745"}[chunkId] + ".chunk.js";
};